/**
 * TasksAssigned Queries
 */

import gql from 'graphql-tag'

export const getPrintTicketsListQuery = gql`
  query myPrintTicketsList(
    $limit: Int
    $offset: Int
    $order: String
    $orderAs: String
    $searchText: String
    $startDate: String
    $endDate: String
    $status: String
  ) {
    ticketsResults: myPrintTicketsList(
      limit: $limit
      offset: $offset
      order: $order
      orderAs: $orderAs
      searchText: $searchText
      startDate: $startDate
      endDate: $endDate
      status: $status
    ) {
      fullCount
      tickets {
        id
        shortId: short_id
        requesterFirstName: requester_first_name
        requesterLastName: requester_last_name
        createdAt: created_at
        type
        origin
        fabric
        code
        thumbnail
        imported
        designId: design_id
        proDesignId: prodesign_id
        status
        archived
      }
    }
  }
`

export const getDesigners = gql`
  query getAllDesigners {
    designersResult: getAllDesigners {
      shortId: short_id
      email
      firstName: first_name
      lastName: last_name
    }
  }
`

export const archiveTicketMutation = gql`
  mutation archiveTicket($shortId: String!, $archived: Boolean) {
    result: archiveTicket(shortId: $shortId, archived: $archived) {
      message
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TestPrintList/data.ts